import { Component, DestroyRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { ActivatedRoute } from '@angular/router';
import { UserRiskAssessmentRoutes } from 'src/app/core/enums/routes.enum';
import {
  RISK_ASSESSMENT_VALUE_DELETE_PRIVILEGE,
  RISK_ASSESSMENT_VALUE_UPDATE_PRIVILEGE,
  RiskAssessmentValueType,
} from 'src/app/risk-assessment-admin/enums/risk-assessment-value-type.enum';
import { ALERT_STATUS_TITLES } from 'src/app/risk-assessment-user/enums/alert-status.enum';
import { RiskAssessmentAction } from 'src/app/risk-assessment-user/enums/risk-assessment-action.enum';
import { TenantUserPrivilegesService } from 'src/app/tenant-selector/services/tenant-user-privileges.service';
import { Privileges } from 'src/app/core/privileges/privileges';
import { RaRiskColor, RA_RISK_COLOR_HEX } from 'src/app/risk-assessment-user/enums/risk-color.enum';
import { IMaxRiskWithContext } from 'src/app/risk-assessment-user/models/risk-assessment.model';

@Component({
  selector: 'app-risk-assessments-template',
  templateUrl: './risk-assessments-template.component.html',
  styleUrls: ['./risk-assessments-template.component.scss'],
  standalone: false,
})
export class RiskAssessmentsTemplateComponent implements OnChanges, OnInit {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
  @Input() valueType: RiskAssessmentValueType = this.activatedRoute.snapshot.data.valueType;

  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  id = this.activatedRoute.snapshot.params.id;

  UserRiskAssessmentRoutes = UserRiskAssessmentRoutes;
  RiskAssessmentAction = RiskAssessmentAction;
  ALERT_STATUS_TITLES = ALERT_STATUS_TITLES;
  hasCreatePermimssion: boolean;
  hasUpdatePermission: boolean;
  hasDeletePermission: boolean;

  RaRiskColor = RaRiskColor;
  RA_RISK_COLOR_HEX = RA_RISK_COLOR_HEX;

  maxInitialRiskColor: RaRiskColor | null = null;
  maxResidualRiskColor: RaRiskColor | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private tenantUserPrivileges: TenantUserPrivilegesService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.hasCreatePermimssion = this.tenantUserPrivileges.userHasPrivilege(
      Privileges.RiskAssessmentCreate
    );
    this.hasUpdatePermission = this.tenantUserPrivileges.userHasPrivilege(
      RISK_ASSESSMENT_VALUE_UPDATE_PRIVILEGE[this.valueType]
    );
    this.hasDeletePermission = this.tenantUserPrivileges.userHasPrivilege(
      RISK_ASSESSMENT_VALUE_DELETE_PRIVILEGE[this.valueType]
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['element']) {
      this.updateRiskLevels();
    }
  }

  private updateRiskLevels(): void {
    this.maxInitialRiskColor = this.getRiskColor(this.element?.maxInitialRisk);
    this.maxResidualRiskColor = this.getRiskColor(this.element?.maxResidualRisk);
  }

  private getRiskColor(maxRisk: IMaxRiskWithContext | number | undefined): RaRiskColor | null {
    if (maxRisk === undefined || maxRisk === null) return null;
    if (typeof maxRisk !== 'object' || maxRisk.riskColor == null) return null;
    const color = maxRisk.riskColor as RaRiskColor;
    return color in RA_RISK_COLOR_HEX ? color : null;
  }

  getMaxRiskDisplayValue(maxRisk: IMaxRiskWithContext | number | undefined): number | null {
    if (maxRisk === undefined || maxRisk === null) return null;
    return typeof maxRisk === 'object' ? maxRisk.riskRating : maxRisk;
  }
}
